import { PracticeReport, PracticeReportType } from '../types/practice-types';
import { findItemWithHighestFieldValue, isDefined } from './object-utils';

export const getPathWithQuery = (
  path: string,
  queryParams?: Record<string, string | string[] | number | boolean | null | undefined>,
): string => {
  if (!queryParams) return path;
  const array = Object.keys(queryParams)
    .filter(key => isDefined(queryParams[key]))
    .map(key => {
      let value = queryParams[key];
      if (value === undefined || value === null) {
        value = '';
      }
      if (Array.isArray(value)) {
        value = value.join(',');
      }
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    });
  return array.length === 0 ? path : `${path}?${array.join('&')}`;
};

export const getLatestReportUrlByType = (
  reports: PracticeReport[] | undefined,
  type: PracticeReportType,
): string | undefined => {
  const filtered = reports?.filter(r => r.type === type) || [];
  const filePath = findItemWithHighestFieldValue(filtered, 'timestamp')?.path;
  return filePath ? encodeURI(`${getReportsOrigin()}/${filePath}`) : undefined;
};

export const getReportsOrigin = (): string => location.origin.replace('prototype', 'qa');

export const openInANewWindow = (url?: string): void => {
  window.open(url, '_blank', 'noopener,noreferrer');
};
